import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

const variants = {
  primary:   'bg-accent-600 text-white hover:bg-accent-700 shadow-md shadow-accent-600/20',
  secondary: 'bg-white text-navy-700 border border-surface-300 hover:border-surface-400 hover:bg-surface-50',
  ghost:     'text-navy-600 hover:bg-surface-100',
  danger:    'bg-red-600 text-white hover:bg-red-700',
  dark:      'bg-navy-900 text-white hover:bg-navy-800',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs rounded-lg',
  md: 'px-4 py-2.5 text-sm rounded-xl',
  lg: 'px-6 py-3 text-base rounded-xl',
};

const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', loading, disabled, className, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={cn(
        'relative inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200',
        'focus-ring disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {children}
    </button>
  );
});

export default Button;
